export const base_Urls = process.env.REACT_APP_BASE_URL;
export const signUp_Urls = process.env.REACT_APP_SIGNUP_URL;
export const One_time_Token = process.env.REACT_APP_ONE_TIME_TOKEN;
export const Google_Play_Link = process.env.REACT_APP_GOOGLE_PLAY_LINK;
export const App_Store_Link = process.env.REACT_APP_APP_STORE_LINK;
